import React, { Component } from "react";
import Head from "next/head";
import getConfig from "next/config";
import { connect } from "react-redux";
import Link from "next/link";

import { getCmsBlocks } from "@store/app/actions";
import { getSupportCategories } from "@store/support/actions";
import Breadcrumbs from "@components/Breadcrumbs";
import SupportLayout from "@containers/Support/Layout";
import Heading from "@components/Heading";
import ContactsSidebar from "@containers/Contacts/Sidebar";
import Button from "@components/Button";

const {
  publicRuntimeConfig: { settings },
} = getConfig();

class SupportReturnPage extends Component {
  render() {
    return (
      <>
        <Head>
          <title>{`Retur produse`}</title>
        </Head>

        <Breadcrumbs
          breadcrumbs={[
            {
              id: 1,
              level: 2,
              name: `Suport clienti`,
              url_key: "suport-clienti/",
            },
            {
              id: 1,
              level: 99,
              name: `Returneaza produse`,
            },
          ]}
        />

        <SupportLayout categories={this.props.supportCategories}>
          <article className="py-6 lg:flex">
            <div className="lg:w-4/6">
              <Heading
                title={`Returneaza produse`}
                as="h1"
                display="h1"
                classesProp="mb-3"
              />

              {!this.props.user.isLoggedIn ? (
                <>
                  {this.props.cmsBlocks["suport-clienti-retur"] && (
                    <div
                      className="text-sm return-text"
                      dangerouslySetInnerHTML={{
                        __html: this.props.cmsBlocks["suport-clienti-retur"],
                      }}
                    />
                  )}

                  <div className="flex items-center sm:block mt-4">
                    <Button
                      display="inline"
                      href={`${settings.baseUrl}/cont/intra/#section-login`}
                      title={`Intra in cont`}
                    />
                    <br></br>
                    <Link href={`${settings.baseUrl}/cont/intra/`} passHref>
                      <a className="inline-block sm:mt-3 ml-6 sm:ml-0 text-red-brand hover:text-bleu-hover text-sm underline">
                        {`Creeaza cont nou`}
                      </a>
                    </Link>
                  </div>
                </>
              ) : (
                <>
                  {`Pentru a returna unul sau mai multe produse, acceseaza sectiunea`}
                  {` `}
                  <b>{`Retur produse`}</b>
                  {` `}
                  {`din contul tau de client.`}

                  <div className="mt-4">
                    <Button
                      display="inline"
                      href={`${settings.baseUrl}/cont/retururi/`}
                      title={`Mergi la Retur produse`}
                    />
                  </div>
                </>
              )}
            </div>

            <div className="lg:w-2/6 pt-12 lg:pt-0 lg:pl-8">
              <ContactsSidebar cmsBlocks={this.props.cmsBlocks} />
            </div>
          </article>
        </SupportLayout>

        <style jsx>{`
          .return-text p {
            padding-bottom: 1rem;
          }
        `}</style>
      </>
    );
  }
}

SupportReturnPage.getInitialProps = async (ctx) => {
  const { reduxStore } = ctx;

  // Get data from store
  const { categories } = reduxStore.getState().support;
  const promises = [];

  const pageCmsBlocksNames = [
    "contacts-serviciul-relatii-clienti",
    "suport-clienti-retur",
  ];

  const cmsBlocksToRetrieve = pageCmsBlocksNames.filter(
    (cmsBlockName) => !reduxStore.getState().app.cmsBlocks[cmsBlockName]
  );

  if (cmsBlocksToRetrieve.length > 0) {
    promises.push(reduxStore.dispatch(getCmsBlocks(cmsBlocksToRetrieve)));
  }

  // Load data if misssing
  !categories && promises.push(reduxStore.dispatch(getSupportCategories()));

  await Promise.all(promises);
};

SupportReturnPage.pageLayout = "default";

export default connect((state) => ({
  user: state.user,
  cmsBlocks: state.app.cmsBlocks,
  supportCategories: state.support.categories,
}))(SupportReturnPage);
